import { useCallback } from 'react';

import { useSearchParams } from 'react-router-dom';
import { Input, TextInput } from 'ui';
import { IconSearch } from 'ui/Icons';

const CausesSearchInput = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleSearch = useCallback(
    (value: string) => {
      setSearchParams({ search: value });
    },
    [setSearchParams]
  );

  return (
    <TextInput
      placeholder="Search by org name or location"
      value={searchParams.get('search') ?? ''}
      onChange={(e) => handleSearch(e.target.value)}
      leftSection={<IconSearch size={16} stroke={1.5} />}
      size="lg"
      rightSection={
        searchParams.get('search') ? (
          <Input.ClearButton onClick={() => setSearchParams({ search: '' })} size="sm" />
        ) : undefined
      }
      rightSectionPointerEvents="auto"
    />
  );
};

export { CausesSearchInput };
